module.exports = __webpack_public_path__ + "assets/2.png";


//////////////////
// WEBPACK FOOTER
// ./images/2.png
// module id = 695
// module chunks = 0